<template>
  <div class="flavor" v-if="locale.flavor">

    <div class="content-headline">
      <div class="content-headline__wrapper">
        <h1>{{locale.flavor.flavor}}</h1>
      </div>
    </div>

    <div class="table-responsive">
      <table class="responsive">
        <thead>
        <tr>
          <th scope="col">{{locale.flavor.name}}</th>
          <th scope="col">{{locale.flavor.id}}</th>
          <th scope="col">{{locale.flavor.disk}}</th>
          <th scope="col">{{locale.flavor.ram}}</th>
          <th scope="col">{{locale.flavor.cpu}}</th>
        </tr>
        </thead>
        <tbody>
          <template v-for="flavor in flavors">
            <tr :key="flavor.id">
              <td data-label="Name">{{flavor.name}}</td>
              <td data-label="ID">{{flavor.id}}</td>
              <td data-label="Disk">{{flavor.disk}}</td>
              <td data-label="RAM">{{flavor.ram}}</td>
              <td data-label="CPU">{{flavor.cpu}}</td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Flavor',
  computed: {
    ...mapState(['locale']),
    ...mapState({
      flavors: state => state.flavors.flavors,
      loadingState: state => state.loadingState
    })
  }

}
</script>



// WEBPACK FOOTER //
// src/components/Flavor.vue